import { render, staticRenderFns } from "./AlbumItem.vue?vue&type=template&id=cca98efe&scoped=true"
import script from "./AlbumItem.vue?vue&type=script&lang=js"
export * from "./AlbumItem.vue?vue&type=script&lang=js"
import style0 from "./AlbumItem.vue?vue&type=style&index=0&id=cca98efe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca98efe",
  null
  
)

export default component.exports